import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pager } from '../pager/pager';
import { FilterBar } from '../filter-bar/filter-bar';
import { DateTime } from '../datetime/datetime';
import { useGetEventsQuery } from './events.api';
import { useAppDispatch } from '../../app/hooks';
import { open } from '../modal/modalSlice';
import { Card, CardContent } from 'shared-components';
import { PageTitle } from 'shared-components';
import Routes from '../../app/routes';

export const Events = () => {
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [search, setSearch] = useState<string | undefined>(undefined);
  const { data, isLoading } = useGetEventsQuery({
    page,
    perPage,
    search,
  });
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  if (isLoading) {
    return <span>loading...</span>;
  }
  return (
    <>
      <PageTitle
        title="Events"
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.EVENTS.title, link: Routes.EVENTS.link },
        ]}
        furtherActions={[{ value: 'create', display: 'Create Event' }]}
        onAction={async (action) => {
          switch (action) {
            case 'create':
              dispatch(
                open({
                  title: 'Create Event',
                  contentKey: 'create-event',
                })
              );
              break;
          }
        }}
      />
      <Card>
        <CardContent>
          <FilterBar
            //search={true}
            value={{}}
            filters={[]}
            // onFilterChanged={(values) => {
            //   setStatus(values['status']);
            // }}
            onSearch={(term) => {
              setSearch(term === '' ? undefined : term);
            }}
          />
        </CardContent>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {data?.data.map((e) => (
              <tr
                onClick={() => {
                  navigate(`${e._id}`);
                }}
                key={e._id.toString()}
              >
                <td>
                  <DateTime d={e.date} />
                </td>
                <td>{e.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pager
          onNext={() => {
            setPage(page + 1);
          }}
          onPrevious={() => {
            setPage(page - 1);
          }}
          onPageSelected={(selected) => {
            setPage(selected);
          }}
          onPerPageChange={(selected) => {
            setPerPage(selected);
            setPage(1);
          }}
          page={page}
          perPage={perPage}
          totalPages={data?.totalPages ?? 1}
        />
      </Card>
    </>
  );
};
